module.exports = "/images/vendor/flag-icon-css/flags/4x3/sb.svg?aa819297c44f0a9d29fa4aaf18a1bf32";